/* Lemyn exit box (21 Oct 2026, Joe): desktop only. When the mouse heads for the top of the window to leave,
   after 10 s on the page, once per visit, Sarah offers to answer a question. No discount, no email field.
   Never on cart, checkout, account, Pro, sell-online, numbers or replacement pages, or once Sarah was used.
   Taps go to Lemyn Track (lemyn_click) so the numbers page shows whether it keeps people. */
(function(){
  try{
    if(!window.matchMedia || !matchMedia('(pointer:fine)').matches || window.innerWidth < 900) return;
    var p=location.pathname;
    if(/^\/(cart|checkout|checkouts|account|orders)|^\/pages\/(lemyn-pro|sell-online|numbers|my-account|replace)/.test(p)) return;
    var ss=function(k,v){ try{ if(v===undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k,v); }catch(e){ return null; } };
    if(ss('lemyn.exit')==='1') return;
    var t0=Date.now(), shown=false;
    var track=function(l){ try{ if(window.lemynTrack) window.lemynTrack('lemyn_click',{label:l, area:'lc-exit'}); }catch(e){} };
    function show(){
      if(shown || ss('lemyn.exit')==='1' || ss('lemyn.used')==='1' || !window.lemynSarah) return;
      if(document.querySelector('.lc-panel.lc-open')) return;
      shown=true; ss('lemyn.exit','1');
      var st=document.createElement('style');
      st.textContent='.lx-bg{position:fixed;inset:0;background:rgba(11,11,12,.35);z-index:2147483000;display:flex;align-items:flex-start;justify-content:center;padding-top:14vh;animation:lxf .2s ease}'
        +'.lx{width:min(420px,92vw);background:var(--card,#fff);color:var(--ink,#191713);border:2px solid #E8552F;border-radius:22px;padding:22px 22px 18px;box-shadow:0 24px 60px rgba(0,0,0,.25);font-family:"Source Sans 3",-apple-system,sans-serif}'
        +'.lx .k{font:600 11px/1 "IBM Plex Mono",Menlo,monospace;letter-spacing:.2em;text-transform:uppercase;color:#E8552F}'
        +'.lx h3{font:900 26px/1.1 Archivo,"Helvetica Neue",Arial,sans-serif;letter-spacing:-.02em;margin:10px 0 6px}'
        +'.lx p{color:var(--mute,#6E6458);font-size:16px;line-height:1.5;margin:0}'
        +'.lx .b{display:flex;gap:10px;margin-top:18px}.lx button{flex:1;padding:14px;border-radius:14px;font:800 15px/1 Archivo,sans-serif;cursor:pointer;border:0}'
        +'.lx .y{background:#E8552F;color:#fff}.lx .n{background:transparent;color:inherit;border:1.5px solid var(--line,#E6DAC8)}'
        +'@keyframes lxf{from{opacity:0}to{opacity:1}}';
      document.head.appendChild(st);
      var bg=document.createElement('div'); bg.className='lx-bg'; bg.setAttribute('role','dialog'); bg.setAttribute('aria-label','Before you go');
      bg.innerHTML='<div class="lx"><div class="k">Sarah · Lemyn concierge</div><h3>Before you go</h3><p>Any question about our products? Sarah answers in seconds.</p>'
        +'<div class="b"><button type="button" class="y">Ask Sarah</button><button type="button" class="n">No thanks</button></div></div>';
      document.body.appendChild(bg);
      var close=function(l){ if(l) track(l); bg.remove(); document.removeEventListener('keydown',esc); };
      var esc=function(e){ if(e.key==='Escape') close('Exit box: No thanks'); };
      document.addEventListener('keydown',esc);
      bg.addEventListener('click',function(e){ if(e.target===bg) close('Exit box: No thanks'); });
      bg.querySelector('.n').onclick=function(){ close('Exit box: No thanks'); };
      bg.querySelector('.y').onclick=function(){ close('Exit box: Ask Sarah'); try{ window.lemynSarah.open(); }catch(e){} };
      bg.querySelector('.y').focus();
      track('Exit box shown');
    }
    document.addEventListener('mouseout',function(e){
      if(e.relatedTarget || e.toElement) return;
      if(e.clientY > 8) return;
      if(Date.now()-t0 < 10000) return;
      show();
    });
  }catch(e){}
})();
